import { Bell, CircleAlert, ShoppingCart } from 'lucide-react'
import { Badge } from '@/components/ui/badge'
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from '@/components/ui/tooltip'
import type { EmployeeManualOrder } from '@/api/employee-manual-order'

interface OrderFlagBadgesProps {
  order: Pick<EmployeeManualOrder, 'is_cash' | 'is_store' | 'shipping_partial' | 'shipping_remark'>
}

/** 订单号下方的提示标记胶囊：货到付款 / 仓库保管 / 部分发货（悬停展示发货备注） */
export function OrderFlagBadges({ order }: OrderFlagBadgesProps) {
  if (!order.is_cash && !order.is_store && !order.shipping_partial) {
    return null
  }

  return (
    <div className="mt-1 flex flex-wrap gap-1">
      {order.is_cash && (
        <Badge variant="secondary" className="bg-red-50 text-red-700 hover:bg-red-50">
          <CircleAlert className="mr-1 h-3 w-3" />
          货到付款
        </Badge>
      )}
      {order.is_store && (
        <Badge variant="secondary" className="bg-amber-50 text-amber-700 hover:bg-amber-50">
          <Bell className="mr-1 h-3 w-3" />
          仓库保管
        </Badge>
      )}
      {order.shipping_partial && (
        <TooltipProvider>
          <Tooltip delayDuration={0}>
            <TooltipTrigger asChild>
              <span className="inline-flex">
                <Badge variant="secondary" className="bg-blue-50 text-blue-700 hover:bg-blue-50">
                  <ShoppingCart className="mr-1 h-3 w-3" />
                  部分发货
                </Badge>
              </span>
            </TooltipTrigger>
            {order.shipping_remark && (
              <TooltipContent
                side="top"
                className="max-w-sm"
                aria-label={order.shipping_remark}
              >
                部分发货：{order.shipping_remark}
              </TooltipContent>
            )}
          </Tooltip>
        </TooltipProvider>
      )}
    </div>
  )
}
